import { AvatarCatalogEntry, BrandKitAvatar } from 'types'

export const DEFAULT_CATALOG_KEYS = ['mark_davis', 'chloe_nguyen', 'arthur_pendelton']

export interface AvatarDraft {
  localId: string
  name: string
  personaNote: string
  age?: string
  ethnicity?: string
  catalogKey?: string
  mediaFileId?: number
  photoUrl: string
  voicePreset?: string | null
  voiceMediaFileId?: number | null
  voiceSampleUrl?: string
  createdId?: number
}

export const draftFromCatalog = (entry: AvatarCatalogEntry): AvatarDraft => ({
  localId: entry.key,
  name: entry.name,
  personaNote: entry.persona_note,
  age: entry.age,
  ethnicity: entry.ethnicity,
  catalogKey: entry.key,
  photoUrl: entry.photo_url,
  voicePreset: entry.voice.preset_name,
  voiceSampleUrl: entry.voice.sample_audio_url,
})

// Adapter so the real AvatarCard can render an un-persisted draft. Display-only: drafts have no DB id
// yet, so a negative index-based id is used purely as a stable, non-colliding React/test key.
export const avatarFromDraft = (draft: AvatarDraft, index: number): BrandKitAvatar => ({
  id: -(index + 1),
  brand_kit_id: 0,
  name: draft.name,
  source: draft.catalogKey ? 'catalog' : 'custom_photo',
  persona_note: draft.personaNote,
  age: draft.age ?? null,
  ethnicity: draft.ethnicity ?? null,
  enabled: true,
  verification_status: 'verified',
  verification_failure: null,
  media_file_id: draft.mediaFileId ?? 0,
  photo_url: draft.photoUrl,
  voice: draft.voiceSampleUrl
    ? {
        voice_type: 'preset',
        preset_name: draft.voicePreset ?? null,
        display_name: null,
        media_file_id: draft.voiceMediaFileId ?? null,
        sample_audio_url: draft.voiceSampleUrl,
      }
    : null,
})
